import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UiService } from '../core/services/ui.service';

export const LoginGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const ui = inject(UiService);
  const tts = inject(TranslateService);

  let user = localStorage.getItem('currentUser');
  if (!user) {
    ui.errorSnack(tts.instant('You are not authorized!'));
    router.navigate(['login']);
    return false;
  }
  return true;
};
